import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../../shared/services/local-storage-service';
import { ACCESS_TOKEN_KEY } from '../constants/storage-keys';

/** Libera a rota apenas quando existe o token de acesso salvo por token-verify. */
export const authGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);

  return localStorageService.get(ACCESS_TOKEN_KEY) ? true : router.createUrlTree(['/token-invalido']);
};
